import { render, staticRenderFns } from "./Registrati.vue?vue&type=template&id=564ce415&scoped=true&"
import script from "./Registrati.vue?vue&type=script&lang=js&"
export * from "./Registrati.vue?vue&type=script&lang=js&"
import style0 from "./Registrati.vue?vue&type=style&index=0&id=564ce415&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ce415",
  null
  
)

export default component.exports